export const buildUrl = (endpoint: string, countryCode: string): string =>
  `${endpoint}?countryCode=${encodeURIComponent(countryCode)}`;
